import React from 'react';
import { HashLink } from 'react-router-hash-link';

const navItems = [
    { label: 'Home', to: '/#about' },
    { label: 'Research', to: '/#research-section' },
    { label: 'Recruit', to: '/#recruit-section' },
    { label: 'News', to: '/#news-section' },
    { label: 'Publication', to: '/publication' },
    { label: 'People', to: '/people' },
    { label: 'Contact', to: '/contact' },
];

const Header = () => {
    const [menuOpen, setMenuOpen] = React.useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="header">
            {/* Desktop */}
            <div className="content-desktop">
                <div className='banner'>
                    <HashLink smooth to="/">ICML</HashLink>
                </div>
                <div className="navbar">
                    {navItems.map((item) => (
                        <div key={item.label} className="navbar-item">
                            <HashLink smooth to={item.to}>{item.label}</HashLink>
                        </div>
                    ))}
                </div>
            </div>

            {/* Mobile */}
            <div className="content-mobile">
                <div className='banner'>
                    <HashLink smooth to="/">ICML</HashLink>
                </div>
                <button
                    className="burger-button"
                    onClick={() => setMenuOpen((prev) => !prev)}
                    aria-label="메뉴 열기"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            {menuOpen && (
                <div className="mobile-menu">
                    {navItems.map((item) => (
                        <div key={item.label} className="mobile-menu-item">
                            <HashLink smooth to={item.to} onClick={closeMenu}>
                                {item.label}
                            </HashLink>
                        </div>
                    ))}
                </div>
            )}
        </header>
    );
};

export default Header;
